import type { PropsWithChildren } from "react";
import { Tab, TabList, TabPanels, Tabs } from "@chakra-ui/react";
import { VendorPortalTab } from "modules/agency-settings/screens/feature-preferences/components/tabs/vendor-portal-tab";

function PortalTab({ children }: Required<PropsWithChildren>) {
  return (
    <Tab flexGrow={0} minW={"max-content"}>
      {children}
    </Tab>
  );
}

export function PortalTabs() {
  return (
    <Tabs w={"100%"} colorScheme={"blue"}>
      <TabList>
        <PortalTab>Vendor Portal</PortalTab>
      </TabList>
      <TabPanels pt={2}>
        <VendorPortalTab />
      </TabPanels>
    </Tabs>
  );
}
